<template>
    <div v-if="!su" class="popup profile-wrap">
        <!-- <vue-headful  title="Change Password"  description="Change Password"  />  -->
        <div class="title"> Forgot password
            <div class="close">
                <router-link to="/"><img src="/img/profile/close-x.svg"/></router-link>
            </div>
        </div>
        <hr class="hr"/>
        <div v-if="id" class="popup-body">
            <div class="form-group">
                <div :class="[{ 'field-error': error['password'] }, 'field-wrapper']">
                    <input :class="['form-control']" v-model="password"/>
                    <label :class="[{ 'filled-label': password && password.length > 0 }]" :for="name">New
                        password</label>
                </div>
                <div v-if="error['password']" class="error"> {{ error["password"] }}</div>
            </div>
            <div class="form-group">
                <div :class="[  { 'field-error': error['confirm_password'] },  'field-wrapper'  ]">
                    <input :class="['form-control']" type="password" v-model="confirm_password"/>
                    <label :class="[  {  'filled-label': confirm_password && confirm_password.length > 0  }  ]"
                           :for="name">Confirm password
                    </label>
                </div>
                <div v-if="error['confirm_password']" class="error"> {{ error["confirm_password"] }}</div>
            </div>
            <div style="clear: both;"></div>
            <div class="form-group" style="margin-top: 25px; text-align: center;">  <!-- <div>-->
                <btn @click.native="change_pass" class="btn btn-success" :load="load">Change password</btn>
                <!-- </div>-->  </div>
        </div>
        <hr class="hr"/>
        <div class="footer">
            <router-link to="/sign-in">Back to Sign in</router-link>
        </div>
    </div>
    <success v-else :title="'Password'" :desc="'Your password was successfully changed'"
             :btn="{ title: 'Go to sign in', url: '/sign-in' }"></success>
</template>

<script>
    import PreloadBtn from "../PreloadBtn.vue";
    import success from "./PopUpSuccess.vue";

    export default {
        data: function () {
            return {
                error: [],
                email: "",
                id: 0,
                key: "",
                su: false,
                load: false,
                password: null,
                confirm_password: null,
                name: null
            };
        },
        components: {
            success: success,
            btn: PreloadBtn
        },
        methods: {
            change_pass: function () {
                this.error = {};
                if (!this.password) {
                    this.error.password = "Password is required";
                }
                if (!this.confirm_password) {
                    this.error.confirm_password = "Confirm Password is required";
                }

                if (this.password && this.password.length < 6) {
                    this.error.password = "must be at least 6 letters";
                }

                if (this.password != this.confirm_password) {
                    this.error.confirm_password = "Confirm Password incorrect";
                }

                console.log("this.error", this.error);

                if (!Object.keys(this.error).length) {
                    var d = new FormData();
                    let th = this;
                    d.set("_csrf", document.querySelector("meta[name=csrf-token]").content);
                    d.set("password", this.password);

                    let url = "/forgot/" + this.id + "/" + this.key;

                    this.load = true;
                    this.$http
                        .post(url, d)
                        .then(function (response) {
                            this.load = false;

                            if (response.body.status == "ok") {
                                this.su = true;
                            }

                            if (response.body.error) {
                                th.error = response.body.error;
                            }
                        })
                        .catch(function (response) {
                        });
                }
            }
        },
        created: function () {
            this.id = this.$route.params.id;
            this.key = this.$route.params.key;
        }
    };
</script>
